export class resetPasswordSendMailModel {

    constructor(
        public mail: string
    ) { }

}


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/resetPasswordSendMailModel.ts